// ai-sidebar/components/assistant-header.tsx
import { ChevronsRight, SquarePen } from "lucide-react";
import { Orb } from "./orb";
import { useAssistant } from "../use-assistant";

function statusLine(status: string): { label: string; dot: string } {
  switch (status) {
    case "thinking":  return { label: "Thinking…", dot: "var(--spectral-violet)" };
    case "streaming": return { label: "Working…",  dot: "var(--spectral-violet)" };
    case "error":     return { label: "Something interrupted", dot: "var(--infrared-coral)" };
    default:          return { label: "Listening", dot: "var(--signal-green)" };
  }
}

export function AssistantHeader() {
  const { status, setCollapsed, messages, resetThread } = useAssistant();
  const working = status === "thinking" || status === "streaming";
  const { label, dot } = statusLine(status);

  return (
    <div
      className="flex items-center justify-between border-b border-border"
      style={{ padding: "18px 18px 15px" }}
    >
      <div className="flex items-center gap-3 min-w-0">
        <Orb size={40} working={working} />
        <div className="min-w-0">
          <div className="font-semibold text-foreground leading-tight truncate">Upmode Assistant</div>
          <div className="flex items-center gap-1.5 mt-0.5">
            <span className="inline-block w-1.5 h-1.5 rounded-full shrink-0" style={{ backgroundColor: dot }} />
            <span className="text-xs text-muted-foreground truncate">{label}</span>
          </div>
        </div>
      </div>
      <div className="flex items-center gap-1 shrink-0">
        {messages.length > 0 && (
          <button
            type="button"
            aria-label="New conversation"
            title="New conversation"
            onClick={resetThread}
            className="flex items-center justify-center rounded-lg border border-border bg-card text-muted-foreground"
            style={{ width: 30, height: 30 }}
          >
            <SquarePen className="w-4 h-4" style={{ strokeWidth: 1.85 }} />
          </button>
        )}
        <button
          type="button"
          aria-label="Collapse assistant"
          onClick={() => setCollapsed(true)}
          className="flex items-center justify-center rounded-lg border border-border bg-card text-muted-foreground"
          style={{ width: 30, height: 30 }}
        >
          <ChevronsRight className="w-4 h-4" style={{ strokeWidth: 1.85 }} />
        </button>
      </div>
    </div>
  );
}
